module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-2-98330875cdaac700c9045f84bb855819.svg";